import React from "react";

/**
 * In-app confirmation modal, replacing window.confirm - which is styled inconsistently with the rest
 * of the portal and is suppressed outright in some embedded browser contexts. Shares the overlay
 * pattern used by ServerUpdateDialog.
 */
export default function ConfirmDialog({
  title = "Are you sure?",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  danger = false,
  onConfirm,
  onClose,
}) {
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="portal-panel"
        style={{
          width: "420px", maxWidth: "92vw", padding: "20px",
          background: "var(--content-bg)", borderRadius: "var(--radius-md)",
        }}
      >
        <h2 style={{ margin: "0 0 8px 0", fontSize: "17px" }}>{title}</h2>
        <p style={{ margin: "0 0 20px 0", color: "var(--text-muted)", fontSize: "var(--fs-xs)" }}>
          {message}
        </p>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button
            onClick={onClose}
            style={{
              padding: "8px 14px", borderRadius: "4px", cursor: "pointer",
              background: "transparent", color: "var(--text-color)",
              border: "1px solid var(--border-color)",
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={() => { onConfirm(); onClose(); }}
            style={{
              padding: "8px 14px", borderRadius: "4px", cursor: "pointer", border: "none",
              background: danger ? "#c0392b" : "var(--brand-mid)", color: "white",
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
